import { createContext, useState, useEffect, useContext } from 'react';
import { TasksContext } from './tasks-context';
import { postTasksComplete } from '../common/api-requests';

const CompleteContext = createContext();

const CompleteProvider = ({ children }) => {
    const [tasks, setTasks] = useContext(TasksContext);
    const [complete, setComplete] = useState([]);
    
    useEffect(() => {

        if (!tasks || !tasks.length || !complete || !complete.length)
            return;

         if (tasks.some(task => complete.some(item => item.id === task.id))){

            if (complete.some(a=>a.isPostComplete)){
                
                // const updTasks = tasks.filter(task => !complete.some(item => item.id === task.id));
                // setTasks(updTasks);
                
                
                postTasksComplete(complete.map(a=>a.id)).then(()=>{
                    const updTasks = tasks.filter(task => !complete.some(item => item.id === task.id));
                    setTasks(updTasks);
                });
            }
            else{
                const updTasks = tasks.filter(task => !complete.some(item => item.id === task.id));
                setTasks(updTasks);
            }
         }

    }, [complete]);

    return (
        <CompleteContext.Provider value={[complete, setComplete]}>
            {children}
        </CompleteContext.Provider>
    )
}

export { CompleteContext, CompleteProvider };